export var DropdownStringsForDocs = function () {
    return {
        /** String to display in the dropdown trigger input placeholder */
        'dropdown.input.trigger.placeholder': 'Select option',
        /** String to display in the dropdown list search input placeholder */
        'dropdown.input.search.placeholder': 'Search ...',
        /** String to display in the label for empty results */
        'dropdown.list.empty.label': 'No options available',
        /** String to display in the label for recently selected */
        'dropdown.list.group.header.empty.label': 'Recent selections:',
        /** String to display in the screen reader instructions when the list result updates / changes options */
        'dropdown.aria.updates': function (results) { return "".concat(results, " options press up and down arrow to select"); },
        /** String to display for any ungrouped options when `groupBy` is set and returns a falsey value */
        'dropdown.list.ungrouped.header': 'Ungrouped',
    };
};
export var DropdownStrings = DropdownStringsForDocs();
